import React from 'react';
import { Link } from '../../atoms/Link';
import './TopNavLink.css';

export interface TopNavLinkProps {
  href: string;
  label: string;
  external?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export const TopNavLink: React.FC<TopNavLinkProps> = ({
  href,
  label,
  external = false,
  className = '',
  style,
}) => {
  return (
    <Link
      href={href}
      external={external}
      noUnderline
      className={`hi-ui hi-ui-topnav-link ${className}`.trim()}
      style={style}
    >
      {label}
    </Link>
  );
};
